'use client';

import { Button } from '@up2stay/up2promo-ui';

import { UpgradeCard } from '@/core/components/billing/upgrade-surfaces';
import { useNavigateShell } from '@/core/hooks/use-navigate-shell';
import { useDictionary } from '@/core/providers/dictionary-provider';
import { shellPaths } from '@/core/router/app-paths';

/** Free-plan surface: feature teaser + upgrade CTA — not a blank 403. */
export function FeedbackTeaser() {
  const dict = useDictionary().feedback.teaser;
  const { navigateShell } = useNavigateShell();

  return (
    <div className="mx-auto flex w-full max-w-lg flex-col gap-4">
      <UpgradeCard feature="feature.feedback" compact={false} />

      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="self-start"
        onClick={() => navigateShell(shellPaths.home)}
      >
        {dict.backToBoard}
      </Button>
    </div>
  );
}
